import { render, staticRenderFns } from "./Waveform.vue?vue&type=template&id=007d9584&scoped=true&"
import script from "./Waveform.vue?vue&type=script&lang=js&"
export * from "./Waveform.vue?vue&type=script&lang=js&"
import style0 from "./Waveform.vue?vue&type=style&index=0&id=007d9584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d9584",
  null
  
)

export default component.exports